module.exports = __webpack_public_path__ + "img/solved-cube-1.753950ad.png";